'use client';
import { Menu, UnstyledButton } from '@mantine/core';
import { IconCheck, IconChevronDown } from '@tabler/icons-react';

export function CatalogFilters({ catalog, labels, onChange }) {
  if (!catalog) return null;
  const selected = labels ? labels.split(',') : [];
  const definitions = catalog.definitions.filter(d => d.filterable);
  const title =
    selected.length === 0
      ? 'All labels'
      : selected.length === 1
        ? definitions.find(d => d.key === selected[0])?.title || '1 label'
        : `${selected.length} labels`;

  function toggle(definition) {
    const next = selected.includes(definition.key)
      ? selected.filter(key => key !== definition.key)
      : [
          ...selected.filter(
            key =>
              definition.group !== 'lifecycle' || definitions.find(d => d.key === key)?.group !== 'lifecycle'
          ),
          definition.key,
        ];
    onChange({ labels: next.sort().join(',') });
  }

  return (
    <Menu position="bottom-end" width={210} withinPortal closeOnItemClick={false}>
      <Menu.Target>
        <UnstyledButton
          aria-label={`Filter by LEGO labels: ${title}`}
          style={{
            height: 30,
            padding: '0 12px',
            border: '1.5px solid #dee2e6',
            borderRadius: 20,
            backgroundColor: '#fff',
            color: '#495057',
            fontSize: 12,
            fontWeight: 500,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          {title}
          <IconChevronDown size={12} aria-hidden="true" />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {definitions.map(definition => (
          <Menu.Item
            key={definition.key}
            renderRoot={props => (
              <button {...props} role="menuitemcheckbox" aria-checked={selected.includes(definition.key)} />
            )}
            rightSection={
              selected.includes(definition.key) ? <IconCheck size={14} aria-hidden="true" /> : null
            }
            onClick={() => toggle(definition)}
          >
            {definition.title}
          </Menu.Item>
        ))}
        {selected.length > 0 && (
          <>
            <Menu.Divider />
            <Menu.Item onClick={() => onChange({ labels: '' })} closeMenuOnClick>
              Clear labels
            </Menu.Item>
          </>
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
